var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDndAction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 14.167C10.8833 14.167 11.3333 13.717 11.3333 13.167C11.3333 12.617 10.8833 12.167 10.3333 12.167C9.78325 12.167 9.33325 12.617 9.33325 13.167C9.33325 13.717 9.78325 14.167 10.3333 14.167Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 14.167C6.21675 14.167 6.66675 13.717 6.66675 13.167C6.66675 12.617 6.21675 12.167 5.66675 12.167C5.11675 12.167 4.66675 12.617 4.66675 13.167C4.66675 13.717 5.11675 14.167 5.66675 14.167Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 4.83301C10.8833 4.83301 11.3333 4.38301 11.3333 3.83301C11.3333 3.28301 10.8833 2.83301 10.3333 2.83301C9.78325 2.83301 9.33325 3.28301 9.33325 3.83301C9.33325 4.38301 9.78325 4.83301 10.3333 4.83301Z",
    fill: "#616161"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 4.83301C6.21675 4.83301 6.66675 4.38301 6.66675 3.83301C6.66675 3.28301 6.21675 2.83301 5.66675 2.83301C5.11675 2.83301 4.66675 3.28301 4.66675 3.83301C4.66675 4.38301 5.11675 4.83301 5.66675 4.83301Z",
    fill: "#616161"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 9.5C10.8833 9.5 11.3333 9.05 11.3333 8.5C11.3333 7.95 10.8833 7.5 10.3333 7.5C9.78325 7.5 9.33325 7.95 9.33325 8.5C9.33325 9.05 9.78325 9.5 10.3333 9.5Z",
    fill: "#616161"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.66675 9.5C6.21675 9.5 6.66675 9.05 6.66675 8.5C6.66675 7.95 6.21675 7.5 5.66675 7.5C5.11675 7.5 4.66675 7.95 4.66675 8.5C4.66675 9.05 5.11675 9.5 5.66675 9.5Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDndAction);
export default __webpack_public_path__ + "static/media/ic_dnd_action.7feb3c8758fed491e70c8f642570423e.svg";
export { ForwardRef as ReactComponent };